module.exports = __webpack_public_path__ + "img/wallet-icon.8c68e2a5.svg";